/**
 * "Thinking time! · 0:42" — the gate's inline row (R6.4). The countdown keeps a
 * display face but at the row's scale: M1a's 44 px `countdown` type needed the
 * 88 px card, and the card is gone.
 */
import React from 'react';
import {View} from 'react-native';

import {Txt} from '../../../../ui';
import {mmss, useCountdown} from '../countdown';
import cardStyles from './cardStyles';

export default React.memo(function ThinkingCardView({until}: {until: number}) {
  const left = useCountdown(until);
  return (
    <View style={cardStyles.rowCard}>
      <View style={cardStyles.text}>
        <Txt variant="label" numberOfLines={1}>
          Thinking time!
        </Txt>
        <Txt variant="captionTight" tone="muted" numberOfLines={1}>
          the board unlocks when the timer ends
        </Txt>
      </View>
      <Txt variant="button" tone="clock" numeric>
        {mmss(left)}
      </Txt>
    </View>
  );
});
